import { Feature } from 'geojson';
import { Map } from 'maplibre-gl';

import { LocationPinLayer } from '@/mapbox-layers/location';
import { IPlaceFeature } from '@/models/search';

import getGeoJSONSource from '../getGeoJSONSource';

export async function addLocationPin(
  map: Map | undefined | null,
  item: IPlaceFeature
) {
  if (!map) return;

  const feature: Feature = {
    geometry: item.geometry,
    properties: {},
    type: 'Feature',
  };
  const source = getGeoJSONSource(map, LocationPinLayer.id);
  if (source) {
    source?.setData({
      features: [feature],
      type: 'FeatureCollection',
    });
  }
}

export async function removeLocationPin(map: Map | undefined | null) {
  if (!map) return;

  const source = getGeoJSONSource(map, LocationPinLayer.id);

  if (source) {
    source.setData({
      features: [],
      type: 'FeatureCollection',
    });
  }
}
